export default __webpack_public_path__ + "static/layout-anatomy-light-a2f9f694d6b736441ba415bb502c8731.png";